import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons, CTAButtonsAlt } from "../../../../../global/components/Buttons/buttons";
import { FormTemplate, FormInput } from "../../../../Components/Forms/InputTemplate";
import { TableActionsDownload } from "../../../../Components/Misc/Actions";
import Table from "../../../../Components/Table/Table";
import FormUploadComponent from "../../../../Components/Forms/FormUploadComponent";
import { useLocation } from "react-router";
import { useState } from "react";
import FormUploader from "../../../../Components/FileUploader/FileUploader";
import { removeListData } from "../../../../../../utils/functions/ResourceFunctions";

const RetirementFormModal = ({
  isOpen,
  setIsOpen,
  isLoading,
  // refresh,
  // setRefresh,
  onValidate = () => { },
  floatAdvanceData,
  vendorDocument,
  setVendorDocument,
  promotionalItemsData,
  openSurveyModal = () => { },
}) => {
  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      fileName: "",
    },
  });
  const {
    formState: { isValid },
  } = formMethods;

  const [uploadFile, setUploadFile] = useState(null);

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Retirement Form</h4>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate>
              <div className="w-full col-span-2">
                <div className={DashboardStyle.labels_group}>
                  <div>
                    <div>
                      <p>Sub-Category:</p>
                      <h4>{floatAdvanceData?.subcategory}</h4>
                    </div>
                    <div>
                      <p>Total Amount:</p>
                      <h4>{floatAdvanceData?.totalAmount}</h4>
                    </div>
                  </div>
                  <div>
                    <div>
                      <p>Budget:</p>
                      {/* <h4>{request?.employeeGroup?.title}</h4> */}
                    </div>
                    <div>
                      <p>Budget Status:</p>
                      {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                    </div>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-2">
                    Components
                  </label>
                  <table className="w-full border">
                    <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                      <tr>
                        <th className="border p-2">S/N</th>
                        <th className="border p-2">Component</th>
                        <th className="border p-2">Optional</th>
                        <th className="border p-2">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {floatAdvanceData?.components?.map((item, index) => {
                        return (
                          <tr className="text-[#4B664C] font-[500]" key={index}>
                            <td className="border p-2">{index + 1}</td>
                            <td className="border p-2">{item.componentName}</td>
                            <td className="border p-2">
                              {item.isCompulsory ? "Yes" : "No"}
                            </td>
                            <td className="border p-2">
                              <div className="border rounded flex items-center space-x-1 p-1 ">
                                <p>₦{item.amount}</p>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Supporting <br /> Documents
                </h4>
                <div className={DashboardStyle.inputs_group_no_grid}>
                  <FormInput
                    camelCase="fileName"
                    title="Document Name"
                    placeholder="Enter document name"
                    isOptional={false}
                  />
                  <FormUploader
                    uploadFile={uploadFile}
                    setUploadFile={setUploadFile}
                    setVendorDocument={setVendorDocument}
                    vendorDocument={vendorDocument}
                  />
                </div>
              </section>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}>
                  Documents <br /> Uploads
                </h4>
                <div
                  className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
                >
                  {vendorDocument?.length === 0 ? (
                    <p>No Record Available</p>
                  ) : (
                    <Table>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>File Name</th>
                          <th>File Type</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {vendorDocument?.map?.((x, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{x?.fileName || x?.file?.name}</td>
                              <td style={{ textTransform: "uppercase" }}>
                                {x?.file?.type?.split("/")?.[1] ||
                                  x?.fileName?.split(".")?.pop()?.toUpperCase() ||
                                  "Unknown"}
                              </td>
                              <td>
                                <TableActionsDownload
                                  file={x?.file || null}
                                  url={x?.fileUrl || null}
                                  actions={() =>
                                    removeListData({
                                      value: index,
                                      list: vendorDocument,
                                      setList: setVendorDocument,
                                    })
                                  }
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  )}
                </div>
              </section>
              <section
                className="p-4 grid grid-cols-2 gap-4"
              >
                <div className="col-span-1">
                  <h4 className={DashboardStyle.form_section_title}>
                    Promotional Item
                  </h4>
                </div>

                <div className="w-full col-span-2">
                  <div className={DashboardStyle.labels_group}>
                    <div>
                      <div>
                        <p>Item Category:</p>
                        <h4>
                          {/* {data?.responseObject?.promotionalItems?.itemCategory} */}
                        </h4>
                      </div>
                      <div>
                        <p>Budget:</p>
                        {/* <h4>{data?.responseObject?.floatAdvance?.totalAmount}</h4> */}
                      </div>
                    </div>
                    <div>
                      <div>
                        <p>Budget Status:</p>
                        {/* <h4>{FormatDateTime(employeecreatedDate, "ll")}</h4> */}
                      </div>
                    </div>
                  </div>
                  <div>
                    <table className="w-full border">
                      <thead className="text-[#29382A] font-[500] bg-[#D9E9DA]">
                        <tr>
                          <th className="border p-2">S/N</th>
                          <th className="border p-2">Items</th>
                          <th className="border p-2">Stock Availability</th>
                          <th className="border p-2">Quantity Requested</th>
                        </tr>
                      </thead>
                      <tbody>
                        {promotionalItemsData?.items?.map(
                          (item, index) => {
                            return (
                              <tr className="text-[#4B664C] font-[500]" key={index}>
                                <td className="border p-2">{index + 1}</td>
                                <td className="border p-2">{item.itemName}</td>
                                <td className="border p-2">{item.availableStock}</td>
                                <td className="border p-2">{item.quantity}</td>
                              </tr>
                            );
                          },
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <CTAButtonsAlt hideIcon={true} disabled={!isValid} onClick={openSurveyModal} type="button" isLoading={isLoading} rightIcon={<RightIcon />}>
                  Survey Questions
                </CTAButtonsAlt>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default RetirementFormModal;

const RightIcon = () => {
  return <div>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 7L15 11M15 11L11 15M15 11H7M1 11C1 16.5228 5.47715 21 11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11Z" stroke="#4B664C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  </div>
}
